/**
* @todo need Documentation.
* This over implementation
* @param term: is an or
*   "filter": [
              {
                "bool": {
                  "should": [
                    {
                      "term": {
                        "partySubType": "E"
                      }
                    },
                    {
                      "term": {
                        "partySubType": "P"
                      }
                    }
                  ],
                  "minimum_should_match": 1
                }
              },
            ],
* @params phrase: is an exact match ->
            ...{
                "match_phrase": {
                  "country": "AT"
                }
              }
*/
export var SearchFilterType;
(function (SearchFilterType) {
    /** Match phrase filter
     * https://www.elastic.co/guide/en/elasticsearch/reference/8.8/query-dsl-match-query-phrase.html
     */
    SearchFilterType["PHRASE"] = "phrase";
    /**
     * Term filter
     * https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-term-query.html#term-field-params
     */
    SearchFilterType["TERM"] = "term";
    /**
     * Term filter with case_insensitive enabled (usefull for e.g. enums)
     * https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-term-query.html#term-field-params
     */
    SearchFilterType["TERM_CASE_INSENSITIVE"] = "KEYWORD";
    /**
     * Term filter but with a boolean must_not
     * https://www.elastic.co/guide/en/elasticsearch/reference/8.8/query-dsl-bool-query.html
     */
    SearchFilterType["NOT_TERM"] = "not_term";
    /**
     * Filters out ids
     */
    SearchFilterType["NOT_IDS"] = "not_ids";
    /**
     * Filters within a date range based on the MUI daterange format we use
     */
    SearchFilterType["DATE_RANGE"] = "date_range";
    /**
     * Filters like DATE_RANGE but also allows null
     */
    SearchFilterType["DATE_RANGE_OR_NULL"] = "date_range_or_null";
})(SearchFilterType || (SearchFilterType = {}));
export var SearchSortOrder;
(function (SearchSortOrder) {
    SearchSortOrder["ASC"] = "asc";
    SearchSortOrder["DESC"] = "desc";
})(SearchSortOrder || (SearchSortOrder = {}));
export var SearchSortFormat;
(function (SearchSortFormat) {
    SearchSortFormat["DATE"] = "date";
})(SearchSortFormat || (SearchSortFormat = {}));
export var SearchSortParams;
(function (SearchSortParams) {
    function create(order, format) {
        return { order, format };
    }
    SearchSortParams.create = create;
})(SearchSortParams || (SearchSortParams = {}));
